import { render, staticRenderFns } from "./BrandAccounting.vue?vue&type=template&id=0d0fca46&scoped=true"
import script from "./BrandAccounting.vue?vue&type=script&lang=ts"
export * from "./BrandAccounting.vue?vue&type=script&lang=ts"
import style0 from "./BrandAccounting.vue?vue&type=style&index=0&id=0d0fca46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0fca46",
  null
  
)

export default component.exports